import { useCallback, useState } from 'react';

/**
 * จำว่า section ไหนถูกพับไว้ — ใช้กับรายการสินทรัพย์ที่แบ่งตามแพลตฟอร์ม
 *
 * เก็บชุดที่ **พับ** ไม่ใช่ชุดที่กาง ทุก section จึงเริ่มแบบกางออก
 * แพลตฟอร์มที่เพิ่งเพิ่มเข้ามาจะไม่ถูกซ่อนไว้จนผู้ใช้นึกว่าบันทึกไม่สำเร็จ
 */
export function useCollapsedGroups() {
  const [collapsed, setCollapsed] = useState<ReadonlySet<string>>(() => new Set());

  const toggle = useCallback((key: string) => {
    setCollapsed((previous) => {
      const next = new Set(previous);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }, []);

  return { isOpen: (key: string) => !collapsed.has(key), toggle };
}

/** ลูกศรของหัว section — ชี้ลงเมื่อกาง ชี้ขวาเมื่อพับ */
export function Chevron({ open }: { open: boolean }) {
  return (
    <svg
      viewBox="0 0 16 16"
      aria-hidden
      fill="currentColor"
      className={`size-3.5 shrink-0 text-ink-400 transition-transform ${open ? '' : '-rotate-90'}`}
    >
      <path d="M3 5.5h10L8 11.5Z" />
    </svg>
  );
}
